import { IPromise } from 'angular';
import { call, put } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { CatalogChangeContentActions } from '../../../../catalog/contentActions/CatalogChangeContactActions';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { SetContactAction } from '../../../actions/spaces/SetContactAction';
import { reloadSpaceIfUpdatingCurrentSpace } from './RefreshContentSagas';


export function* handleSetContact(action: SetContactAction) {
  try {

    try {
      yield call(openContactDialog, action.item);
    } catch {
      return;
    }

    const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, [action.item]);
    if (!maybeReloaded) {
      yield put(requestSpaceContents());
    }
  } catch(e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function openContactDialog(externalContentItem: IContentInfo): IPromise<any> {
  return CatalogChangeContentActions.confirmChangeContact(externalContentItem.contentType, externalContentItem);
}
